<template>
  <div
    :id="module.id"
    class="benefits"
    :style="{
      backgroundColor: module.config.general.moduleBackgroundColor.value,
    }"
  >
    <GlobalUIMedia
      :media="module.config.general.media"
      v-if="module.config.general.showMedia"
      :lazy="lazy"
    />

    <div class="benefits-container" :style="modulePadding">
      <Benefit
        v-for="benefit in module.modules"
        :key="benefit.id"
        :id="benefit.id"
        :module="benefit"
        :parentModule="module"
      />
    </div>
  </div>
</template>

<script>
import GlobalUIMedia from "../../GlobalUI/GlobalUIMedia.vue";
import Benefit from "../Benefit/Benefit.vue";
import benefitsModule from "./benefitsDefaultModuleProp";

import { globalComputed } from "../../GlobalUI/mixins/global.js";

export default {
  name: "Benefits",
  mixins: [globalComputed],
  components: {
    Benefit,
    GlobalUIMedia,
  },
  props: {
    module: {
      type: Object,
      default() {
        return benefitsModule;
      },
    },
    lazy: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@include reset;

.benefits {
  position: relative;

  container-type: inline-size;
  contain: layout;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
}

.benefits-container {
  display: flex;
  flex-wrap: wrap;
  gap: 50px;
  justify-content: center;

  width: 100%;
  max-width: 1600px;
  padding-inline: var(--cr-module-padding-large);

  @include laptop {
    padding-inline: calc(var(--cr-module-padding-large) / 2);
  }

  @include mobile {
    padding-inline: 25px;
  }
}
</style>
